import {Component, ViewChildren, QueryList, Output, EventEmitter, AfterViewInit} from "@angular/core";
import {Hint} from "./hint.directive";
import "rxjs/add/operator/debounceTime";
import "rxjs/add/operator/distinctUntilChanged";
import "rxjs/add/operator/filter";


enum KEYS  {
    UP = 38,
    DOWN = 40,
    ENTER = 9,
    TAB = 13,
    ESC = 27
}


export class SuggestionsComponent implements AfterViewInit {

     hints: QueryList<Hint>;

     selectHint: EventEmitter<any> = new EventEmitter();

    items: Array<any>;

    private pointedHint: Hint;

    ngAfterViewInit(): void {
        // viewChild is set after the view has been initialized
        let onHints: (hints: QueryList<Hint>) => void = (hints: QueryList<Hint>) => {
            this.linkHintsArray(hints.toArray());
            this.point(hints.first);
        };

        this.hints.changes
            .filter(hints => hints.length > 0)
            .subscribe(onHints);

        onHints(this.hints);
    }

    onKeyDown(key: number): void {
        if (KEYS.UP === key) {
            this.point(this.pointedHint.prev);
        } else if (KEYS.DOWN === key) {
            this.point(this.pointedHint.next);
        } else if (KEYS.ESC === key) {
            this.hide();
        } else if ([KEYS.ENTER, KEYS.TAB].indexOf(key) >= 0) {
            this.select(this.pointedHint);
        }
    }

    point(hint: Hint): void {
        // with timeout to handle property change after checked 
        setTimeout(() => {
            let previous: Hint = this.pointedHint;
            this.pointedHint = hint;
            this.pointedHint.activate();
            if (previous) previous.deactivate();
        }, 1);
    }

    hide(): void {
        this.items = undefined;
        this.pointedHint = undefined;
    }

    select(hint: Hint): void {
        this.selectHint.emit(hint.data);
        this.hide();
    }

    hasItems(): boolean {
        return this.items && this.items.length > 0;
    }

    private linkHintsArray(hintsArray: Hint[]): void {
        hintsArray.forEach(linkWithNeighbours);

        function linkWithNeighbours(hint: Hint, index: number): void {
            if (index > 0) hint.prev = hintsArray[index - 1]; else hint.prev = hintsArray[hintsArray.length - 1];
            if (index < hintsArray.length - 1) hint.next = hintsArray[index + 1]; else hint.next = hintsArray[0];
        }
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "a2ui-suggestions",
    templateUrl: "src/bootstrap/typeahead/hints.component.html"
}, ] },
];
/** @nocollapse */
static ctorParameters: ({type: any, decorators?: DecoratorInvocation[]}|null)[] = [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'hints': [{ type: ViewChildren, args: [Hint, ] },],
'selectHint': [{ type: Output },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
